module.exports = __webpack_public_path__ + "img/x-white.7df350b2.svg";